import React from "react";
import { useParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import CategorySlider from "../../../CategorySlider";


/* ================= DELHI NCR CITY DATA ================= */

const delhiNCRCities = [
  { slug: "delhi", city: "Delhi", state: "Delhi NCR" },
  { slug: "noida", city: "Noida", state: "Delhi NCR" },
  { slug: "gurugram", city: "Gurugram", state: "Delhi NCR" },
  { slug: "faridabad", city: "Faridabad", state: "Delhi NCR" },
  { slug: "ghaziabad", city: "Ghaziabad", state: "Delhi NCR" }
];

const DelhiNCR = () => {
  const { city } = useParams();

  /* ================= STATE PAGE ================= */
  if (!city) {
    return (
      <div style={{  backgroundColor: "#FFF5F5", marginTop: "90px", padding: "25px", lineHeight: "1.8" }}>
        <h1>Sex Toys Delivery in Delhi NCR</h1>

        <p>
          Buy premium <strong>sex toys in Delhi NCR</strong> with fast & discreet
          delivery. LushDesire is India’s trusted adult wellness store offering
          genuine products for men, women & couples.
        </p>

        <h2>Cities We Serve in Delhi NCR</h2>

        <ul>
          {delhiNCRCities.map((c) => (
            <li key={c.slug}>
              <Link to={`/sex-toys-delivery/delhi-ncr/${c.slug}`}>
                Sex Toys in {c.city}
              </Link>
            </li>
          ))}
        </ul>

        <h3>Why Buy Sex Toys Online from LushDesire?</h3>
        <p>
          We focus on privacy, quality, and customer satisfaction. All products
          are body-safe, discreetly packed, and delivered quickly across Delhi NCR.
        </p>
      </div>
    );
  }

  /* ================= CITY PAGE ================= */
  const cityData = delhiNCRCities.find((c) => c.slug === city);

  if (!cityData) {
    return (
      <div style={{ marginTop: "120px", padding: "30px" }}>
        <h2>City not found</h2>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Sex Toys in {cityData.city} | Discreet Delivery in Delhi NCR
        </title>
        <meta
          name="description"
          content={`Buy sex toys in ${cityData.city} with fast & discreet delivery. Premium adult toys, couples wellness products & COD available across Delhi NCR.`}
        />
      </Helmet>
      <CategorySlider />


      <div style={{   backgroundColor: "#FFF5F5", padding: "25px", lineHeight: "1.8" }}>
        {/* H1 */}
        <h1>Sex Toys in {cityData.city} – 100% Discreet Delivery</h1>

        <p>
          Buy original <strong>sex toys in {cityData.city}</strong> from
          LushDesire and enjoy complete privacy, premium quality, and fast local
          delivery across Delhi NCR.
        </p>

        {/* H2 */}
        <h2>Buy Sex Toys Online in {cityData.city}</h2>
        <p>
          Shopping for adult toys in {cityData.city} is now safe and hassle-free.
          Our curated collection includes pleasure and wellness products designed
          for comfort, safety, and intimacy.
        </p>

        {/* H3 */}
        <h3>Popular Adult Toys Available in {cityData.city}</h3>
        <ul>
          <li>✔ Vibrators & Bullet Massagers</li>
          <li>✔ Dildos & Realistic Toys</li>
          <li>✔ Couples Sex Toys</li>
          <li>✔ Male Masturbators</li>
          <li>✔ Female Pleasure & Wellness Products</li>
        </ul>

        {/* H3 */}
        <h3>Why Choose LushDesire in {cityData.city}?</h3>
        <ul>
          <li>✔ 100% Discreet & Plain Packaging</li>
          <li>✔ Fast Delivery in {cityData.city}</li>
          <li>✔ Cash on Delivery Available</li>
          <li>✔ Secure Payments & Trusted Brand</li>
          <li>✔ Genuine & Body-Safe Products</li>
        </ul>

        {/* H4 */}
        <h4>Discreet Sex Toys Delivery Across Delhi NCR</h4>
        <p>
          We deliver sex toys safely across {cityData.city}, Delhi, Noida,
          Gurugram, Faridabad, and Ghaziabad. Your order is packed with zero adult
          branding to ensure complete confidentiality.
        </p>

        {/* H4 */}
        <h4>Who Can Buy Sex Toys from LushDesire?</h4>
        <p>
          Our products are suitable for beginners as well as experienced users.
          Whether you are shopping solo or as a couple, we offer something for
          every preference.
        </p>

        {/* H5 */}
        <h5>Frequently Asked Questions</h5>
        <p>
          <strong>Is delivery discreet?</strong> Yes, all orders are shipped in
          plain packaging.<br />
          <strong>Do you offer COD?</strong> Yes, Cash on Delivery is available
          in most areas of {cityData.city}.<br />
          <strong>Are products genuine?</strong> Yes, we sell only original and
          body-safe products.
        </p>

        {/* H5 */}
        <h5>Order Sex Toys in {cityData.city} Today</h5>
        <p>
          Experience pleasure with confidence. Order online today and enjoy
          premium adult wellness products delivered discreetly to your doorstep.
        </p>

        <p>
          <strong>LushDesire</strong> – Trusted Online Sex Toy Store in Delhi NCR.
        </p>
      </div>
    </>
  );
};

export default DelhiNCR;
